window.ttx = window.ttx || {};
ttx.attachment = {};

// 附件接口地址（字段级 objectId 与单据级 billNo 共用；以 / 开头会走 ttx.ajax 的网关前缀）
ttx.attachment._urls = {
    upload: '/api/attachment/upload',
    list: '/api/attachment/list',
    delete: '/api/attachment/delete',
};

ttx.attachment._config = {
    accept: '',
    maxSize: 10,
    maxCount: 5,
};

ttx.attachment.config = function (options) {
    if (!options) return;
    Object.assign(ttx.attachment._config, options);
    if (options.urls) Object.assign(ttx.attachment._urls, options.urls);
};

/**
 * 获取文件列表（字段级 objectId 或单据级 billNo 均可作为关联键传入）
 * @param {string} objectId
 * @param {Function} [callback] 可选回调 (err, files)
 * @returns {Promise<Array>|undefined} 无 callback 时返回 Promise
 */
ttx.attachment.getFileList = function (objectId, callback) {
    if (!objectId) {
        if (typeof callback === 'function') { callback(null, []); return; }
        return Promise.resolve([]);
    }
    var promise = ttx.ajax.request({
        url: ttx.attachment._urls.list,
        method: 'POST',
        data: { objectId: objectId },
    }).then(function (ret) { return (ret.res && ret.res.data) || []; });
    if (typeof callback === 'function') {
        promise.then(function (files) { callback(null, files); }, function (err) { callback(err); });
        return undefined;
    }
    return promise;
};

/**
 * 删除附件（按文件 id 列表）
 * @param {number[]|string[]} ids
 * @param {Function} [callback] 可选回调 (err, res)
 */
ttx.attachment.deleteAttachment = function (ids, callback) {
    if (!ids || (Array.isArray(ids) && ids.length === 0)) {
        var ok = { code: 200, msg: '没有需要删除的文件' };
        if (typeof callback === 'function') { callback(null, ok); return; }
        return Promise.resolve(ok);
    }
    var promise = ttx.ajax.request({
        url: ttx.attachment._urls.delete,
        method: 'POST',
        data: { ids: ids },
    }).then(function (ret) { return ret.res; });
    if (typeof callback === 'function') {
        promise.then(function (res) { callback(null, res); }, function (err) { callback(err); });
        return undefined;
    }
    return promise;
};

/**
 * 统一文件上传（字段级 objectId / 单据级 billNo 共用底层）
 * @param {Object} options
 *   - files: File | File[]
 *   - objectId: 字段级关联对象ID（可选，缺省时服务端生成）
 *   - billNo: 单据号（单据级上传，等价于 objectId=billNo）
 *   - userId: 上传用户ID（可选）
 *   - onProgress: 上传进度回调 ({ percent, loaded, total })
 *   - showErrorToast: 是否自动提示错误（默认 true）
 * @param {Function} [callback] 可选回调 (err, data)
 * @returns {Promise|undefined} 无 callback 时返回 Promise，resolve 服务端返回的 data
 */
ttx.attachment.upload = function (options, callback) {
    var opts = options || {};
    var files = opts.files;
    if (!files) {
        var err = new Error('缺少 files 参数');
        if (typeof callback === 'function') { callback(err); return; }
        return Promise.reject(err);
    }
    var fileList = Array.isArray(files) ? files : [files];
    if (!fileList.length) {
        var err2 = new Error('没有需要上传的文件');
        if (typeof callback === 'function') { callback(err2); return; }
        return Promise.reject(err2);
    }

    var fd = new FormData();
    fileList.forEach(function (f) { fd.append('files', f); });
    var objectId = opts.billNo || opts.objectId || '';
    if (objectId) fd.append('objectId', objectId);
    if (opts.userId) fd.append('userId', opts.userId);

    var promise = new Promise(function (resolve, reject) {
        ttx.ajax.xhrUtil({
            url: ttx.attachment._urls.upload,
            method: 'POST',
            data: fd,
            headers: {},
            showErrorToast: opts.showErrorToast !== false,
            onUploadProgress: opts.onProgress,
            success: function (res) { resolve(res.data); },
            error: function (e) { reject(e); }
        });
    });
    if (typeof callback === 'function') {
        promise.then(function (data) { callback(null, data); }, function (e) { callback(e); });
        return undefined;
    }
    return promise;
};

// ===================== 单据级文件上传 API（以 billNo 为关联维度） =====================

/**
 * 单据级上传：把文件挂到指定单据号下
 * @param {string} billNo 单据号
 * @param {File|File[]} files
 * @param {Function} [callback] (err, data)
 * @param {Object} [options] 同 upload 的其它选项（userId / onProgress 等）
 */
ttx.attachment.uploadBillFiles = function (billNo, files, callback, options) {
    var opts = Object.assign({}, options || {}, { billNo: billNo, files: files });
    return ttx.attachment.upload(opts, callback);
};

/** 单据级：获取单据下的文件列表 */
ttx.attachment.getBillFileList = function (billNo, callback) {
    return ttx.attachment.getFileList(billNo, callback);
};

/** 单据级：删除单据下的文件（按文件 id 列表） */
ttx.attachment.deleteBillFiles = function (ids, callback) {
    return ttx.attachment.deleteAttachment(ids, callback);
};

ttx.attachment._formatSize = function (bytes) {
    if (!bytes || bytes === 0) return '0 B';
    var units = ['B', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
};

ttx.attachment._buildUploadModal = function (options, callback) {
    var config = ttx.attachment._config;
    var accept = options.accept || config.accept;
    var maxSize = options.maxSize || config.maxSize;
    var maxCount = options.maxCount || config.maxCount;
    var modalInstance = null;
    var tableBodyEl = null;
    var fileRows = [];       // { file: File, name, size, uploaded: bool }
    var uploading = false;
    var uploadedObjectId = options.objectId || null;

    /* ---- DOM helpers ---- */
    function createEl(tag, style, text) {
        var el = document.createElement(tag);
        if (style) el.style.cssText = style;
        if (text) el.textContent = text;
        return el;
    }

    /* ---- 表格渲染 ---- */
    function renderTable() {
        tableBodyEl.innerHTML = '';
        if (fileRows.length === 0) {
            var emptyRow = createEl('tr', '');
            var emptyCell = createEl('td', 'text-align:center;padding:32px 16px;color:#86909c;font-size:14px;', '暂无文件');
            emptyCell.colSpan = 3;
            emptyRow.appendChild(emptyCell);
            tableBodyEl.appendChild(emptyRow);
            return;
        }

        fileRows.forEach(function (row, idx) {
            var tr = createEl('tr', 'border-bottom:1px solid #f2f3f5;transition:background 0.2s;');
            tr.addEventListener('mouseenter', function () { tr.style.background = '#f7f8fa'; });
            tr.addEventListener('mouseleave', function () { tr.style.background = ''; });

            /* 文件名 */
            var tdName = createEl('td', 'padding:9px 16px;font-size:14px;color:#1d2129;');
            tdName.textContent = row.name;
            tr.appendChild(tdName);

            /* 大小 */
            var tdSize = createEl('td', 'padding:9px 16px;font-size:14px;color:#86909c;white-space:nowrap;');
            tdSize.textContent = ttx.attachment._formatSize(row.file.size);
            tr.appendChild(tdSize);

            /* 状态 */
            var tdStatus = createEl('td', 'padding:9px 16px;font-size:14px;white-space:nowrap;');
            if (row.uploaded) {
                tdStatus.textContent = '已上传';
                tdStatus.style.color = '#00b42a';
            } else {
                tdStatus.textContent = '待上传';
                tdStatus.style.color = '#ff7d00';
            }
            tr.appendChild(tdStatus);

            /* 删除按钮 */
            var tdDel = createEl('td', 'padding:9px 8px;text-align:center;');
            var delBtn = createEl('button', 'border:none;background:transparent;color:#86909c;cursor:pointer;font-size:16px;padding:2px 6px;border-radius:2px;transition:all 0.2s;', '×');
            delBtn.addEventListener('mouseenter', function () { delBtn.style.color = '#f53f3f'; delBtn.style.background = '#fff2f0'; });
            delBtn.addEventListener('mouseleave', function () { delBtn.style.color = '#86909c'; delBtn.style.background = 'transparent'; });
            delBtn.type = 'button';
            delBtn.addEventListener('click', (function (i) {
                return function () { fileRows.splice(i, 1); renderTable(); };
            })(idx));
            tdDel.appendChild(delBtn);
            tr.appendChild(tdDel);

            tableBodyEl.appendChild(tr);
        });
    }

    /* ---- 添加附件 ---- */
    function addFiles() {
        if (fileRows.length >= maxCount) {
            ttx.toast && ttx.toast.warning && ttx.toast.warning('最多上传 ' + maxCount + ' 个文件');
            return;
        }
        var input = document.createElement('input');
        input.type = 'file';
        if (accept) input.accept = accept;
        input.multiple = true;
        input.addEventListener('change', function () {
            var files = input.files;
            if (!files || !files.length) return;
            for (var i = 0; i < files.length; i++) {
                if (fileRows.length >= maxCount) {
                    ttx.toast && ttx.toast.warning && ttx.toast.warning('最多上传 ' + maxCount + ' 个文件');
                    break;
                }
                var file = files[i];
                if (maxSize && file.size > maxSize * 1024 * 1024) {
                    ttx.toast && ttx.toast.warning && ttx.toast.warning('文件 ' + file.name + ' 超过 ' + maxSize + 'MB 限制');
                    continue;
                }
                fileRows.push({ file: file, name: file.name, uploaded: false });
            }
            renderTable();
        });
        input.click();
    }

    /* ---- 上传到服务器 ---- */
    function doUpload() {
        var pending = fileRows.filter(function (r) { return !r.uploaded; });
        if (pending.length === 0) {
            ttx.toast && ttx.toast.info && ttx.toast.info('没有需要上传的文件');
            return;
        }
        if (uploading) return;
        uploading = true;

        var files = pending.map(function (r) { return r.file; });
        // 复用统一上传 API；弹窗内部自行 toast，故关闭全局错误提示避免重复
        ttx.attachment.upload({
            files: files,
            objectId: uploadedObjectId,
            showErrorToast: false
        }, function (err, data) {
            uploading = false;
            if (err) {
                ttx.toast && ttx.toast.error && ttx.toast.error(err.message || '上传失败');
                return;
            }
            if (data && data.objectId) {
                uploadedObjectId = data.objectId;
                pending.forEach(function (r) { r.uploaded = true; });
                renderTable();
                ttx.toast && ttx.toast.success && ttx.toast.success('上传成功');
            } else {
                ttx.toast && ttx.toast.error && ttx.toast.error('上传失败');
            }
        });
    }

    /* ---- 确定 ---- */
    function confirm() {
        var pending = fileRows.filter(function (r) { return !r.uploaded; });
        if (pending.length > 0) {
            ttx.toast && ttx.toast.warning && ttx.toast.warning('还有文件未上传，请先上传');
            return;
        }
        if (modalInstance) modalInstance.close('confirm');
        callback(null, uploadedObjectId || null);
    }

    /* ---- 构建 Modal ---- */
    var bodyEl = createEl('div', 'display:flex;flex-direction:column;gap:12px;');

    /* 工具栏按钮 */
    var toolbarEl = createEl('div', 'display:flex;gap:8px;');

    var addBtn = createEl('button', 'height:32px;padding:0 14px;border:1px solid #d9d9d9;background:#fff;color:#333;border-radius:4px;cursor:pointer;font-size:13px;', '添加附件');
    addBtn.type = 'button';
    addBtn.addEventListener('click', addFiles);

    var uploadBtn = createEl('button', 'height:32px;padding:0 14px;border:1px solid #1677ff;background:#1677ff;color:#fff;border-radius:4px;cursor:pointer;font-size:13px;', '上传');
    uploadBtn.type = 'button';
    uploadBtn.addEventListener('click', doUpload);

    toolbarEl.appendChild(addBtn);
    toolbarEl.appendChild(uploadBtn);

    /* 表格（仿 Arco Design 样式） */
    var tableEl = createEl('table', 'width:100%;border-collapse:collapse;border:1px solid #e5e6eb;border-radius:4px;overflow:hidden;');
    var thead = createEl('thead', '');
    var headerRow = createEl('tr', 'background:#f7f8fa;');
    ['文件名', '大小', '状态', ''].forEach(function (title) {
        var th = createEl('th', 'padding:9px 16px;text-align:left;font-size:14px;font-weight:500;color:#1d2129;border-bottom:1px solid #e5e6eb;' + (title === '' ? 'width:40px;text-align:center;' : ''));
        if (title === '大小' || title === '状态') th.style.whiteSpace = 'nowrap';
        th.textContent = title;
        headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    tableEl.appendChild(thead);

    tableBodyEl = createEl('tbody', '');
    tableEl.appendChild(tableBodyEl);

    bodyEl.appendChild(toolbarEl);
    bodyEl.appendChild(tableEl);

    renderTable();

    modalInstance = ttx.modal._create({
        title: '上传附件',
        content: bodyEl,
        width: 560,
        showFooter: true,
        okText: '确定',
        cancelText: '取消',
        closeOnEsc: true,
        closeOnMask: true,
        onOk: function () { confirm(); },
        onClose: function () {
            if (!uploading) callback(null, null);
        }
    });

    return modalInstance;
};

ttx.attachment.openModal = function (options, callback) {
    return ttx.attachment._buildUploadModal(options || {}, callback || function () {});
};
